import React, { Component } from "react";
import GridTable from "@/components/display/table/gridTableCore";
import fetchHandler from "@/fetch/fetchHandler";
import { initModals } from "@/state/action/comAction";
import ModalMulterCore from "@/components/feedback/scModalMulterCore";
import PropTypes from "prop-types";
import RefreshGrid from "@/utils/refreshGrid";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import DispatchPermissionsModal from "./dispatchPermissionsModal";
import FormCore from "../../../components/display/form/formCore";
// 国际化切换语言
import {
  getPermissionList,
  getUserMenuList,
  deletePermission,
} from "../../../fetch/fetchApi";

@connect((state) => state)
class PermissionList extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.permissionList;
    this.state = {
      gridData: null,
      modalVisible: !1,
      modalTitle: "",
      fromData: [],
      target: [],
      inputValue: "",
      defaultTitle: "",
      defaultType: undefined,
    };
    // 定义modals
    this.modalConfig = [
      {
        key: "dispatchPermissionsModal",
        width: 900,
        title: this.internationalization.title1, // '权限设置',
        content: DispatchPermissionsModal,
      },
    ];
    this.permissionType = {
      1: this.internationalization.title2, // '菜单读权限',
      2: this.internationalization.title3, // '菜单分配权限',
      3: this.internationalization.title4, // '数据城地区查询权限'
    };
    this.layout = [
      "inline", // 横向布局
      "vertical", // 弹窗布局
      "horizontal", // 纵向布局
    ];
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
  };

  init() {
    this.formConfig = {
      childItems: [
        {
          type: "input",
          inputType: "text",
          param: {
            name: "name", // 提交的参数
            type: "string",
          },
          labelName: this.internationalization.title5, // '权限名称',
          placeholder: this.internationalization.placeholder1, // '请输入权限名称'
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "submit",
              text: this.internationalization.btn1, // '查询',
              // icon: 'search'
            },
            {
              btnType: "button",
              text: this.internationalization.btn2, // '新增权限',
              icon: "plus",
              handler: () => {
                this.context.store.dispatch(
                  initModals("dispatchPermissionsModal", {
                    treeSource: this.state.fromData,
                    treeTarget: [],
                    isAdmin: this.state.isAdmin,
                  }),
                );
              },
            },
          ],
        },
      ], // 设置表单元素
      layout: this.layout[0], // 设置布局 0： 横向布局， 1：弹窗布局 2： 全页表单布局
      formTarget: "grid", // 表单提交类型，设置grid则为更新grid
      defaultParams: {},
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      tableKey: "permissionsTable",
    };
    this.tableConfig = {
      tableKey: "permissionsTable",
      tableColumns: [
        {
          name: this.internationalization.title6, // '权限名称',
          key: "name",
          colType: "tipCol",
        },
        //     {
        //     name: '类别',
        //     key: 'type',
        //     align: 'center',
        //     colType: 'textCol',
        //     render: (text) => {
        //         return this.permissionType[text + ''] || '--';
        //     }
        // },
        {
          name: this.internationalization.action, // '操作',
          key: "action",
          align: "center",
          colType: "action",
          actionMap: [
            {
              type: "href",
              actionName: this.internationalization.btn3, // '编辑权限',
              handler: (res) => {
                const treeSource = this.state.fromData;
                const targetArr = res.menuIds ? res.menuIds.split(",") : [];
                this.context.store.dispatch(
                  initModals("dispatchPermissionsModal", {
                    permissionId: res.id || res.key,
                    type: res.type,
                    name: res.name,
                    treeSource: treeSource,
                    treeTarget: targetArr,
                    isSecondAdmin: res.isSecondAdmin,
                    isAdmin: this.state.isAdmin,
                  }),
                );
              },
            },
            {
              type: "confirm",
              actionName: this.internationalization.btn4, // '删除', // 默认actionName
              // 根据grid数据 自定义显示actionName
              handler: (res) => {
                fetchHandler(deletePermission, {
                  permissionId: res.key,
                }).then((result) => {
                  if (result.code === "success") {
                    RefreshGrid(this.context.store, "permissionsTable");
                  }
                });
              },
            },
          ],
        },
      ],
      tableParam: {
        pagecount: 10,
      },
      tableInfo: {
        // footer: <Button type="primary" title="新增权限"
        // onClick={this.openNewPermission.bind(this)}>新增权限</Button>
      },
      dataApi: getPermissionList,
      autoRefresh: !0, // 设置为true 直接加载grid数据
    };
  }

  componentWillMount() {
    this.params = {};
    this.getUserMenuList();
    this.isAdmin();
    this.init();
  }

  openNewPermission() {
    this.context.store.dispatch(
      initModals("dispatchPermissionsModal", {
        treeSource: this.state.fromData,
        treeTarget: [],
        isAdmin: this.state.isAdmin,
      }),
    );
  }

  async getUserMenuList() {
    try {
      const resData = await getUserMenuList();
      const formatBeforeData = resData.data.data;
      const fromData = JSON.parse(
        JSON.stringify(formatBeforeData)
          .replace(/id/g, "key")
          .replace(/childList/g, "children"),
      );
      this.setState({
        fromData: fromData || [],
      });
    } catch (e) {
      console.debug(e);
    }
  }

  isAdmin() {
    // let isAdmin=null;
    // fetchHandler(secondAdminOrNot).then((res) => {
    //     if (res.code === 'success') {
    //         if(res.data&&res.data.length>0) {
    //             isAdmin=-1;
    //         }else{
    //             isAdmin=1;
    //         }
    //         this.setState({
    //             isAdmin: isAdmin
    //         });
    //     }
    // });
  }

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-panel">
          {/* <Button type="primary" title="新增权限" onClick={()=>{ */}
          {/*    this.context.store.dispatch(initModals('dispatchPermissionsModal', { */}
          {/*        treeSource: this.state.fromData, */}
          {/*        treeTarget: [], */}
          {/*        isAdmin: this.state.isAdmin */}
          {/*    })); */}
          {/* }}>新增权限</Button> */}
          <div className="page-toolbar">
            <FormCore formConfig={this.formConfig} />
          </div>
          <div className="page-panel">
            <GridTable config={this.tableConfig} />
          </div>
        </div>
      </div>
    );
    return (
      <div>
        <ModalMulterCore config={this.modalConfig}></ModalMulterCore>
        {Content}
      </div>
    );
  }
}

export default injectIntl(PermissionList);



// WEBPACK FOOTER //
// ./src/AntD/pages/system/permissions/permissionList.js